import { Column, Copy, Row } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export function ChildAccountTableHeader(): JSX.Element {
  return (
    <Row>
      <Column>
        <Copy variant="body" color="secondaryText">
          Added child accounts
        </Copy>
      </Column>
    </Row>
  );
}
